import { SAVE_CONFIGURATION } from 'store/actions/configurationAction'
import { LOAD_REPORT_FINISHED } from 'store/actions/reportAction'
import { DEFAULT_AVM_DISPLAY_TYPE_BY_COUNTRY } from 'constants/valuationEstimatesConstant'
import { DEFAULT_PREFERENCE_REPORT_SECTIONS } from 'constants/reportDefaults'

const INITIAL_STATE = {
  avmDisplayType: null,
  bodyBackgroundColor: '#fafafa',
  disclaimer: null,
  footerBackgroundColor: '#fafafa',
  footerFontColor: '#828282',
  footerLogoUrl: null,
  headerBackgroundColor: '#38424A',
  headerFontColor: '#ffffff',
  headerLogoUrl: null,
  logoClickThroughUrl: null,
  preferenceId: null,
  marketingImageUrl: null,
  marketingMobileImageUrl: null,
  menuTextColor: '#949494',
  menuHoverColor: '#FFFFFF',
  menuActiveColor: '#3399FF',
  preferenceReportSections: [...DEFAULT_PREFERENCE_REPORT_SECTIONS]
}

export default function preferenceReducer(state = INITIAL_STATE, action = {}) {
  // TODO: Change to switch statement when adding more conditions
  if (action.type === LOAD_REPORT_FINISHED) {
    if (!action.payload.preference) {
      return {
        ...state,
        avmDisplayType: DEFAULT_AVM_DISPLAY_TYPE_BY_COUNTRY[action.payload.countryCode]
      }
    }

    return { ...state, ...action.payload.preference }
  } else if (action.type === SAVE_CONFIGURATION) {
    return {
      ...state,
      headerLogoUrl: `${action.payload.publicUrl}/assets/logo/CotalityCream.svg`,
      footerLogoUrl: `${action.payload.publicUrl}/assets/logo/CotalityCream.svg`
    }
  } else {
    return state
  }
}
